import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button, CircularProgress
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteConfirmationDialog = ({ open, onClose, onConfirm, file, deleting }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete File</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete <strong>{file?.Filename}</strong>?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button 
        onClick={onConfirm} 
        color="error" 
        disabled={deleting}
        startIcon={deleting ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmationDialog;